import theme from 'assets/theme/theme';

const styles = () => ({
    root: {
        width: '100%',
        heigth: '100%',
        paddingRight: theme.spacing(2),
        paddingLeft: theme.spacing(2),
        paddingBottom: theme.spacing(1),
        paddingTop: theme.spacing(4)
    },
    tabListBigDiv: {
        display: 'flex',
        width: '100%',
        justifyContent: 'center',
    },
    tabListContainer: {
        display: 'flex',
        width: '50%',
        minWidth: 460,
    },
    tabLine: {
        display: 'flex',
        width: '100%',
        flexWrap: 'wrap',
        justifyContent: 'center',
    },
    '@media (max-width: 600px)': {
        tabListContainer: {
            display: 'flex',
            width: '90%',
            minWidth: 145,
        },
        tabLine: {
            display: 'flex',
            width: '100%',
            flexWrap: 'nowrap',
            justifyContent: 'flex-start',
            flexDirection: 'column',
        },
    }
});

export default styles;
